(ns admin.subscriptions.questionnaires
  (:require [re-frame.core :refer [reg-sub subscribe] :as re-frame]))


;;TODO remove

(defn questionnaires [{:keys [questionnaires]}] questionnaires)

(reg-sub :questionnaires questionnaires)

(defn questionnaire
  [questionnaires [_ {:keys [questionnaire-type questionnaire-uuid]}]]
  (if (and (= questionnaire-type :floating)
           (some? questionnaire-uuid))
    (get-in questionnaires [questionnaire-type questionnaire-uuid])
    (get questionnaires questionnaire-type)))

(reg-sub :questionnaires/questionnaire
         #(subscribe [:questionnaires])
         questionnaire)

(defn questions [{:keys [questions]}] questions)

(reg-sub :questionnaires/questions
         #(subscribe [:questionnaires/questionnaire (last %)])
         questions)

(defn questionnaire-is-updating
  [{:keys [request]} _]
  (let [requests
        (select-keys request
                     [:activity-questions/create-activity-question
                      :activity-questions/update-activity-question
                      :questionnaires/update-questionnaire
                      :questionnaires/delete-questionnaire
                      :questionnaires/create-question-context
                      :questionnaires/update-question-context
                      :questionnaires/delete-question-context
                      :questionnaires/adjust-question-sort-order])]

    (->> requests
         vals
         (filter #(= :loading (:status %)))
         (count)
         (pos?))))

(reg-sub :questionnaires/questionnaire-is-updating
         questionnaire-is-updating)
